var React = require('react');

function Remove (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"24","height":"24","key":0}),React.createElement("path",{"fill":"#C40A0A","d":"M5.14644661,5.85355339 C4.95118446,5.65829124 4.95118446,5.34170876 5.14644661,5.14644661 C5.34170876,4.95118446 5.65829124,4.95118446 5.85355339,5.14644661 L19,18 C19.1952621,18.1952621 19.1952621,18.5118446 19,18.7071068 C18.8047379,18.9023689 18.4881554,18.9023689 18.2928932,18.7071068 L5.14644661,5.85355339 Z","key":1}),React.createElement("path",{"fill":"#C40A0A","d":"M5.85355339,18.5814755 C5.65829124,18.7767376 5.34170876,18.7767376 5.14644661,18.5814755 C4.95118446,18.3862133 4.95118446,18.0696308 5.14644661,17.8743687 L17.8743687,5.14644661 C18.0696308,4.95118446 18.3862133,4.95118446 18.5814755,5.14644661 C18.7767376,5.34170876 18.7767376,5.65829124 18.5814755,5.85355339 L5.85355339,18.5814755 Z","key":2})]));
}

Remove.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Remove;

Remove.default = Remove;



//////////////////
// WEBPACK FOOTER
// ./src/app/icons/remove.svg
// module id = 296
// module chunks = 0